module.exports = __webpack_public_path__ + "img/LatenBanner.cf1b80e9.jpg";